module.exports = "/_next/static/images/nhlWhiteIcon@3x-1d6322a393f8d51b3ff69171742495fb.png";